import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaBehance
} from "react-icons/fa";

const SocialShare = [
  { Social: <FaFacebookF />, link: "https://www.facebook.com/IamE1337/" },
  { Social: <FaTwitter />, link: "https://twitter.com/iamE1337" },
  { Social: <FaInstagram />, link: "https://www.instagram.com/i_am_e1337" },
  { Social: <FaLinkedinIn />, link: "https://www.linkedin.com/in/ernestmena/" },
  { Social: <FaBehance />, link: "https://www.behance.net/ernestmena" },
];

const Social = () => {
  return (
    <div className="nav social-icons justify-content-center">
      {SocialShare.map((val, i) => (
        <a key={i} href={`${val.link}`} rel="noreferrer" target="_blank">
          {val.Social}
        </a>
      ))}
    </div>
  );
};

export default Social;
